import { render, staticRenderFns } from "./CreatedCompany.vue?vue&type=template&id=e48c2698"
import script from "./CreatedCompany.vue?vue&type=script&lang=js"
export * from "./CreatedCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports